<div>
  <div class="dialog-header">
    <h4 mat-dialog-title>Update repository</h4>
    <button mat-dialog-close matIconButton aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <mat-form-field class="update-field" floatLabel="always">
      <mat-label>GitLab Repository Name</mat-label>
      <input matInput [placeholder]="data.repoName" readonly />
      <mat-hint>GitLab repository name for git pull.</mat-hint>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    @if (isLoading$()) {
      <mat-icon><mat-spinner diameter="20"></mat-spinner></mat-icon>
    }
    <button matButton="filled" (click)="updateRepo()" [disabled]="isLoading$()">Update</button>
  </mat-dialog-actions>
</div>
